import React from 'react';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { Provider } from 'react-redux';
import storage from 'redux-persist/lib/storage';
import {
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
//import { composeWithDevTools } from 'redux-devtools-extension';

import bankStatementJourneyReducer from './features/bankStatementJourneySlice';
import limitEnhancementJourneyReducer from './features/limitEnhancementJourneySlice';
import itrJourneyReducer from './features/itrJourneySlice';
import authSlice from './features/authSlice';
import PrePanJourneyReducer from './features/prePanJourneySlice';
import PostPanJourneyReducer from './features/postPanJourneySlice';
import DashboadReducer from './features/dashboardSlice';
import RepaymentSlice from './features/repaymentSlice';
import LoHoldReducer from './features/loHoldSlice';
import EditProfileReducer from './features/editProfileSlice';
import deviceInfoSlice from './features/deviceInfoSlice';
import checkoutSlice from './features/checkoutSlice';
import kycSlice from './features/kycSlice';
import uiControlsSlice from './features/ui-controls';
import leQuestionsJourneySlice from './features/leQuestionsSlice';
import cashDisbursementJourneySlice from './features/cashDisbursementJourneySlice';
import cashTenureSlice from './features/cashTenureSlice';
import promoCodeSlice from './features/promoCodeSlice';
import sendOtpSlice from './features/sendOtpSlice';
import verifyOtpSlice from './features/verifyOtpSlice';
import loanCreationSlice from './features/loanCreationSlice';
import loanStatusSlice from './features/loanStatusSlice';
import consentLetterSlice from './features/consentLetterSlice';
import cashTenureMigrationSlice from './features/cashTenureMigrationSlice';
import certificateSlice from './features/certificateSlice';
import CertificateBootstrap from '../components/common/certificate-bootstrap';

// import MasterRouterReducer from "./features/masterRouterSlice";
import { encryptTransform } from 'redux-persist-transform-encrypt';
import autoDebitSlice from './features/autoDebitSlice';
import nachCancellationSlice from './features/nachCancellationSlice';
import agentLedSlice from './features/agentLedSlice';
import { decrypt } from '../utils/secure';

const appReducers = combineReducers({
  bankStatementJourney: bankStatementJourneyReducer,
  limitEnhancementJourney: limitEnhancementJourneyReducer,
  itrJourney: itrJourneyReducer,
  auth: authSlice,
  prePanJourney: PrePanJourneyReducer,
  postPanJourney: PostPanJourneyReducer,
  dashboard: DashboadReducer,
  repayment: RepaymentSlice,
  loHold: LoHoldReducer,
  editProfile: EditProfileReducer,
  deviceInfo: deviceInfoSlice,
  checkout: checkoutSlice,
  kyc: kycSlice,
  uiControls: uiControlsSlice,
  leQuestionsJourney: leQuestionsJourneySlice,
  autoDebit: autoDebitSlice,
  consentLetter: consentLetterSlice,
  nachCancellation: nachCancellationSlice,
  agentLed: agentLedSlice,
  // masterRouter: MasterRouterReducer,
  cashDisbursement: cashDisbursementJourneySlice,
  cashTenure: cashTenureSlice,
  promoCode: promoCodeSlice,
  sendOtp: sendOtpSlice,
  verifyOtp: verifyOtpSlice,
  loanCreation: loanCreationSlice,
  loanStatus: loanStatusSlice,
  cashTenureMigration: cashTenureMigrationSlice,
  certificate: certificateSlice,
});

const rootReducer = (state, action) => {
  // if (action.type === 'USER_LOGOUT') {
  if (
    action.type === 'postPanJourney/clearState' ||
    action.type === 'prePanJourney/clearState'
  ) {
    // for all keys defined in your persistConfig(s)
    storage.removeItem('persist:root');
    // return appReducers(undefined, action)
    const certificate = state?.certificate;
    state = certificate ? { certificate } : {};
  }
  return appReducers(state, action);
};

const persistConfig = {
  key: 'root',
  storage,
  transforms: [
    encryptTransform({
      secretKey: decrypt(
        null,
        process.env.REACT_APP_ENCRYPTED_REDUX_HYDRATE_KEY,
        true
      ),
      onError: function (error) {
        // DOCS: Clearing the state on encryption error
        console.log('[INFO] Error in encryptTransform redux store: ', error);
        console.log('[INFO] Cleaning Old State ...');
        localStorage.clear();
        window.location.reload();
      },
    }),
  ],
  // blacklist: ["postPanJourney", "prePanJourney"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

const persistor = persistStore(store);

// Handle read by `utils/secure/certificate.js` and `utils/secure/fetch-certificate.js`.
// Those run inside plain functions (`SecureClient`), not React components, so
// they cannot use hooks. Reading the store through this global also keeps them
// out of the store's import graph, which would otherwise be a cycle.
if (typeof window !== 'undefined') {
  window.__REDUX_STORE__ = store;
}

export function StoreProvider({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {/* Fetches the getcertificate public key once, after rehydration */}
        <CertificateBootstrap />
        {children}
      </PersistGate>
    </Provider>
  );
}
